import axios from "axios";

const { CancelToken } = axios;

export default CancelToken;
